import React from 'react';
import { cn } from '@/lib/utils';
import { Loader } from '@/components/ui/loader';

type Props = {
    message?: string;
    className?: string;
};

export const LoadingScreen = ({ className, message = 'Loading...' }: Props) => {
    return (
        <div
            className={cn(
                'w-full flex flex-1 flex-col items-center justify-center py-4',
                className,
            )}
        >
            <Loader className="mb-4" />
            <p>{message}</p>
        </div>
    );
};
